import * as React from "react";

import '../login/login.css';

import { SharedDocumentsComponent } from '../sharedDocuments/SharedDocumentsComponent';

export const PublicShareDocuments = () => {
    return <SharedDocumentsComponent permissionId="73" path="Compartilhamento Público"/>
}
